var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"prt-bottom-bar-element",attrs:{"active-class":"active","exact":"","tag":"button","to":_vm.goal}},[_c('prt-icon',{attrs:{"icon":_vm.icon}}),_c('label',[_vm._v(_vm._s(_vm.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }